let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eLqaR")).then(() => parcelRequire('7fi5S'));